/**
 * 删除数组中某键值对应的数组元素
 */
Array.prototype.removeByKey = function(key, val) {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i][key] === val) {
      this.splice(i, 1);
      break;
    }
  }
};

/**
 * 返回数组是否包含某键值对应的数组元素
 */
Array.prototype.findByKey = function(key, val) {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i][key] === val) {
      return this[i];
    }
  }
};

/**
 * 检测数组是否包含某键值对应的数组元素
 */
Array.prototype.checkByKey = function(key, val) {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i][key] === val) {
      return true;
    }
  }
  return false;
};

/**
 * 比较两个数组内的元素是否一致
 * @param {Object} obj
 */
Array.prototype.equals = function(obj) {
  // 对象若为数组
  if (Object.prototype.toString.call(obj) === '[object Array]') {
    if (this.sort().toString() === obj.sort().toString()) {
      return true;
    } else {
      return false;
    }
  } else {
    // 若为对象
    return false;
  }
};
